import React from 'react';
import ReactDOM from 'react-dom/client';
import './globals.css';
import App from './App';
import { pushNotificationsService } from './lib/push';

// Device-first: captura o token FCM e (se a permissão for concedida)
// registra no backend já no boot, independente de auth. O claim por user
// é feito por `PushLifecycleSetup` quando o login resolve.
void pushNotificationsService.prepare();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
